import { Money } from '@/components/ui/Money';
import {
  COMMON_COLUMNS,
  MONEY_NUM_FMT,
  type DrilldownColumn,
} from '@/components/dashboards/drilldown/drilldown-columns-shared';

/**
 * Drill-down columns for the QUOTED and BOOKED tiles (owner 2026-10-28).
 *
 * One row per quote. `number` is the EMERGE `EQ-…` number (never Xero's
 * `QU-…`), `company` is the Billing name (the server sends it), `date` is the
 * quote's issue date (the window date both metrics use), `status` is the quote
 * stage name (display only), `amount` is `sub_total` (ex VAT) in the quote's
 * own currency, and `grossAmount` is `grand_total` (incl. VAT).
 *
 * Keys are the shared keys plus `grossAmount`: the ColumnManager stores hidden
 * ids, so never rename one.
 */
export const QUOTED_COLUMNS: DrilldownColumn[] = [
  { ...COMMON_COLUMNS.number, label: 'EQ number' },
  { ...COMMON_COLUMNS.title, label: 'Subject' },
  COMMON_COLUMNS.company,
  COMMON_COLUMNS.projects,
  COMMON_COLUMNS.accountLead,
  { ...COMMON_COLUMNS.date, label: 'Issue date' },
  { ...COMMON_COLUMNS.status, label: 'Stage' },
  COMMON_COLUMNS.billingRegion,
  COMMON_COLUMNS.currency,
  { ...COMMON_COLUMNS.amount, label: 'Amount (ex VAT)' },
  {
    key: 'grossAmount',
    label: 'Gross',
    get: (row) => row.grossAmount,
    render: (row) => <Money amount={row.grossAmount} currency={row.currency} />,
    numeric: true,
    numFmt: MONEY_NUM_FMT,
    filter: 'range',
  },
  COMMON_COLUMNS.convertedAmount,
];
